import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ExportPropertiesExcel() {
  const [properties, setProperties] = useState([]);

  const fetchProperties = async () => {
    const q = query(collection(db, "properties"), orderBy("createdAt", "desc"));
    const querySnapshot = await getDocs(q);

    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setProperties(data);
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  const exportToExcel = () => {
    const excelData = properties.map((item, index) => ({
      "Sl No": index + 1,
      "Owner Name": item.ownerName,
      "Mobile": item.mobile,
      "Email": item.email,
      "Property Type": item.propertyType,
      "Location": item.location,
      "District": item.district,
      "Land Area": item.landArea,
      "Expected Price": item.price,
      "Facing": item.facing,
      "Road Width": item.roadWidth,
      "Documents": item.documents,
      "Message": item.message,
      "Submit Date": item.submitDate,
      "Submit Time": item.submitTime,
      "Full Date": item.fullDate,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Properties");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(fileData, "property-list-data.xlsx");
  };

  return (
    <div style={{ padding: "40px" }}>
      <h2>Property Data Export</h2>

      <button onClick={exportToExcel}>
        Export Excel
      </button>
    </div>
  );
}

export default ExportPropertiesExcel;